import request from '@/utils/service'

export function addBusinessApi(data) {
  return request({
    url: '/partner/add',
    method: 'post',
    data
  })
}

export function updateBusinessApi(data) {
  return request({
    url: '/partner/update',
    method: 'post',
    data
  })
}

export function businessStatusApi(data) {
  return request({
    url: '/partner/updateStatus',
    method: 'post',
    data
  })
}

export function delBusinessApi(data) {
  return request({
    url: '/partner/delete',
    method: 'post',
    data
  })
}

export function listApi(data) {
  console.log('params :>> ', data)
  return request({
    url: '/partner/list',
    method: 'get',
    params: data
  })
}
